import RegisteredGlobalEvent from "./RegisteredGlobalEvent";

export enum GlobalEventStates {
  failure = 0,
  success = 1,
}

class GlobalEvent<S, T = unknown, U = unknown> {
  private readonly eventObject: HTMLElement | Document;
  private readonly successName: string;
  private readonly failureName: string;
  private readonly registeredEvent: RegisteredGlobalEvent<T, U>;

  constructor(private name: string) {
    this.eventObject = window.document;
    this.successName = `${name}:success`;
    this.failureName = `${name}:failure`;
    this.registeredEvent = new RegisteredGlobalEvent<T, U>(this.successName, this.failureName, this.eventObject);
  }

  /**
   * Return instance of RegisteredEvent
   */
  // @deprecated
  getRegisteredEvent(): RegisteredGlobalEvent<T, U> {
    return this.registeredEvent;
  }

  /**
   * Dispatch result of event
   * We can subscribe for those results by RegisteredEvent
   * @param data
   * @param state
   */
  dispatch(data: T | U, state: GlobalEventStates = GlobalEventStates.success): this {
    this.createEvent(state === GlobalEventStates.success ? this.successName : this.failureName, data);

    return this;
  }

  /**
   * Register event, it can be caught by listen function
   * @param data
   */

  register(data?: S): this {
    this.createEvent(this.name, data);

    return this;
  }

  /**
   * Listen to registered event
   */
  listen(callback: (data: S) => void): this {
    this.eventObject.addEventListener(this.name, ($event: any) => {
      callback($event.detail);
    });

    return this;
  }

  private createEvent(name: string, data?: S | T | U) {
    this.eventObject.dispatchEvent(
      new CustomEvent(name, {
        detail: data,
      })
    );
  }
}

export default GlobalEvent;
